export default "__VITE_ASSET__cb5c8851__"